import * as React from "react";
import { AboutUI } from "components";

const About = () => {
  return <AboutUI />;
};
export { About };
